<ng-template [ngIf]="isModificandoPF">
  <app-loading></app-loading>
</ng-template>
<div class="d-flex mt-1 ">
  <form [formGroup]="modificaPFForm">
    <div class="grid formgrid p-fluid ">
    <div class="field col-4">
      <label for="stato" >Stato</label>
      <p-dropdown inputId="stato" [options]="listeService.opzioniStatoPF" [showClear]="true"
          placeholder="Scegli lo stato" formControlName="stato" [appendTo]="'body'">
          <ng-template let-stato pTemplate="item">
              <div class="flex align-items-center" [appendTo]="'body'">
                  <p-tag
                  [value]="stato.label | uppercase"
                  [style]="{
                   'background-color': stiliService.getStatoPFColor(stato.label) ,
                   'color': '#FFFFFF' ,
                  'border-radius': '6px',
                  'padding': '.25em .25rem',
                  'font-weight': '700',
                  'font-size': '11px',
                  'letter-spacing': '.3px;',
                  'cursor': 'pointer',
                  }"
                  class="mr-1"
                  >
              </p-tag>
              </div>
          </ng-template>
      </p-dropdown>
    </div>
      <div class="field col-8">
        <label for="data" >Data {{labelData}}</label>
        <p-calendar
            formControlName="data"
            id="data"
            [showIcon]="true"
            dateFormat="dd/mm/yy"
            placeholder="Data {{labelData}}"
            [appendTo]="'body'"
          ></p-calendar>
      </div>
   </div>
</form>
</div>
<div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>

  <div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
    <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
    styleClass="p-button-warning"></p-button>
   <p-button  icon="pi pi-check" label="Conferma"
    class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isModificandoPF || !modificaPFForm.valid"></p-button>
</div>

